import React from 'react';
import JoinScreen from './JoinScreen';
import useLocationConnection from './useLocationConnection';

export default function GeolocationDenied() {
  const { pending, error, requestLocation } = useLocationConnection();
  return <JoinScreen denied pending={pending} error={error} onConnect={requestLocation} />;
}
